/* eslint-disable import/prefer-default-export */

import {
  CONVERSION_SET_INITIAL_DATA,
  CONVERSION_SET_CONVERTED_INGREDIENTS,
  CONVERSION_SWITCH_CURRENT_MEASUREMENT_SYSTEM,
  CONVERSION_TOGGLE_EDIT_OPEN,
  CONVERSION_DELETE,
} from '../constants';

export function setInitialConversionData(data) {
  return dispatch => {
    dispatch({ type: CONVERSION_SET_INITIAL_DATA, payload: data });
  };
}

export function setConvertedIngredients(data) {
  return dispatch => {
    dispatch({ type: CONVERSION_SET_CONVERTED_INGREDIENTS, payload: data });
  };
}

export function switchCurrentMeasurementSystem() {
  return dispatch => {
    dispatch({ type: CONVERSION_SWITCH_CURRENT_MEASUREMENT_SYSTEM });
  };
}

export function deleteConversion() {
  return dispatch => {
    dispatch({ type: CONVERSION_DELETE });
  };
}

export function toggleConversionEditOpen() {
  return dispatch => {
    dispatch({ type: CONVERSION_TOGGLE_EDIT_OPEN });
  };
}
